var scope_0 = require('/home/ubuntu/vingtcinq-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/93cd6a9bb682f5810b8ebf8ce299d0e9.js').default;
var scope_1 = require('/home/ubuntu/vingtcinq-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/home/ubuntu/vingtcinq-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f75d0bdf80e7b9cf0a41de531345188d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    